import PropTypes from 'prop-types';
import React from 'react';
import Field from '../../components/Field';

const ResetPassword = ({
  passwordValue,
  repeatPasswordValue,
  repeatPasswordError,
  onPasswordChange,
  onRepeatPasswordChange,
  onSubmit,
  valid,
  isFetching,
  successMessage,
  errorMessage,
  validatePasswordWarning,
}) => (
  <div className="o-wrapper o-wrapper--small">
    <h2 className="c-heading u-text-center u-mt+ u-mb">Reset Password</h2>
    <form
      onSubmit={onSubmit}
      hidden={isFetching || successMessage || errorMessage}
    >
      <div className="u-mb- u-ph">
        The password must be at least 8 characters long and include at least one letter and number.
      </div>
      <Field
        id="password"
        name="pass"
        className="u-mb"
        type="password"
        label="Enter password"
        value={passwordValue}
        errorMessage={validatePasswordWarning}
        error={!!validatePasswordWarning}
        onChange={onPasswordChange}
        required
      />
      <Field
        id="repeatpassword"
        name="repeatpass"
        className="u-mb+"
        type="password"
        label="Repeat password"
        value={repeatPasswordValue}
        errorMessage={repeatPasswordError}
        error={!!repeatPasswordError}
        onChange={onRepeatPasswordChange}
        required
      />
      <button
        type="submit"
        className="c-btn c-btn--secondary"
        style={{ margin: 'auto' }}
        disabled={!valid}
      >
        Reset password
        {valid}
      </button>
    </form>
    <div className="c-heading--large">
      {successMessage || errorMessage}
    </div>
  </div>
);
ResetPassword.propTypes = {
  passwordValue: PropTypes.string,
  repeatPasswordValue: PropTypes.string,
  repeatPasswordError: PropTypes.string,
  onPasswordChange: PropTypes.func,
  onRepeatPasswordChange: PropTypes.func,
  onSubmit: PropTypes.func,
  valid: PropTypes.bool,
  isFetching: PropTypes.bool,
  successMessage: PropTypes.string,
  errorMessage: PropTypes.string,
  validatePasswordWarning: PropTypes.string.isRequired,
};
ResetPassword.defaultProps = {
  passwordValue: '',
  repeatPasswordValue: '',
  repeatPasswordError: '',
  onPasswordChange: null,
  onRepeatPasswordChange: null,
  onSubmit: null,
  valid: false,
  isFetching: false,
  successMessage: '',
  errorMessage: '',
};

export default ResetPassword;




// WEBPACK FOOTER //
// ./src/app/confirmation/components/ResetPassword.jsx